/* TBC gift choice in the cart.

   When a gift offer leaves a choice to the shopper (a size, or one gift among
   several), the gift app (BOGOS) opens its own pop-up and announces it with
   fg-gifts:show-slider, passing the gifts and its add function. This script
   shows that choice inside the cart instead, under "Free with your order",
   and adds through the app's function so the app still validates and
   discounts the gift. Without the event the app's pop-up shows as before.

   The app emits fg-cart:start-process / end-process around every cart check
   and repeats show-slider only while a choice is still open, so a check that
   ends without it clears the choice. */

(function () {
  var html = document.documentElement;
  var strings = readJSON(document.querySelector('[data-tbc-qa-strings]')) || {};
  var live = document.querySelector('[data-tbc-qa-live]');

  var gifts = [];
  var addGift = null;
  var stale = false;
  var staleTimer = null;
  var busy = false;
  var focusVariant = null;
  var soldOut = {};
  var fetched = {};
  var uid = 0;
  var shownAt = 0;
  var pressed = null;

  /* The sizes appear where the product's Add to cart button was, under the
     drawer that just opened: a second click on that button must not pick a
     size. A click counts only if it starts on the size, is not a double
     click, and comes a moment after the sizes or the drawer appeared. */
  var SETTLE_MS = 700;

  function readJSON(node) {
    if (!node) return null;
    try { return JSON.parse(node.textContent); } catch (error) { return null; }
  }

  function root() {
    return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  }

  function announce(text) {
    if (!live) return;
    live.textContent = '';
    if (text) setTimeout(function () { live.textContent = text; }, 40);
  }

  function cleanTitle(title) {
    return String(title || '')
      .replace('🎁', '')
      .replace(/\(100% off\)/i, '')
      .trim()
      .replace(/^free\s+/i, '')
      .trim();
  }

  /* Two payload shapes: grouped by offer, or one flat list of products. */
  function normalize(detail) {
    var list = [];
    (detail.giftsOffer || []).forEach(function (offer) {
      (offer.arrGiftShow || []).forEach(function (gift) {
        list.push({
          offer: String(gift.belongs_to_offer || offer.offer_root),
          title: cleanTitle(gift.title),
          handle: gift.clone_product_handle,
          image: gift.thumbnail,
          variants: (gift.variants || []).map(function (variant) {
            return { id: variant.variant_shopify_id, title: variant.variant_title };
          })
        });
      });
    });
    (detail.gifts || []).forEach(function (gift) {
      list.push({
        offer: String(gift.belongs_to_offer),
        title: cleanTitle(gift.title),
        handle: null,
        image: gift.thumbnail,
        variants: (gift.variants || []).map(function (variant) {
          return { id: variant.id, title: variant.title };
        })
      });
    });
    return list.filter(function (gift) { return gift.variants.length; });
  }

  /* The payload's own stock flag is not reliable; the cloned product is. */
  function loadStock(gift) {
    if (!gift.handle || fetched[gift.handle]) return;
    fetched[gift.handle] = true;
    fetch(root() + 'products/' + gift.handle + '.js', { headers: { Accept: 'application/json' } })
      .then(function (response) { return response.ok ? response.json() : null; })
      .then(function (product) {
        if (!product) return;
        gift.option = product.options && product.options[0] && product.options[0].name;
        product.variants.forEach(function (variant) { soldOut[variant.id] = !variant.available; });
        render();
      })
      .catch(function () {});
  }

  function hint(gift) {
    if (gift.variants.length < 2) return '';
    if (!gift.option || /size|talla/i.test(gift.option)) return strings.gift_size || '';
    return (strings.select || '').replace('__OPTION__', gift.option.toLowerCase());
  }

  /* place: { index, size } of this gift among the gifts of its offer. An
     offer listing several products lets the shopper take one of them:
     "Free gift · Pick one" over the first, "Or" over the next. */
  function build(gift, inDrawer, place) {
    var id = 'tbc-gift-pick-' + (++uid);
    var block = document.createElement('div');
    block.className = 'tbc-gift-pick';
    block.setAttribute('data-tbc-gift-pick', '');
    block.setAttribute('role', 'group');
    block.setAttribute('aria-labelledby', id + '-title ' + id + '-hint');

    var single = gift.variants.length === 1;
    var cells = gift.variants.map(function (variant) {
      var out = soldOut[variant.id] === true;
      var label = single ? (strings.add_to_cart || '') : variant.title;
      return '<button type="button" class="tbc-gift-pick__cell' + (out ? ' tbc-gift-pick__cell--out' : '') + '"' +
        ' data-variant="' + variant.id + '"' +
        (out ? ' aria-disabled="true" aria-label="' + escapeHTML((strings.sold_out_value || '').replace('__VALUE__', variant.title)) + '"' : '') +
        '>' + escapeHTML(label) + '</button>';
    }).join('');

    var label = '';
    if (place.size > 1) {
      label = place.index === 0 ? (strings.gift_label || '') + ' · ' + (strings.gift_pick_one || '') : (strings.gift_or || '');
    } else if (inDrawer && !single) {
      label = (strings.gift_label || '') + ' · ' + hint(gift);
    }
    if (place.size > 1) block.classList.add('tbc-gift-pick--choice');

    block.innerHTML =
      (label ? '<p class="tbc-gift-pick__label">' + escapeHTML(label) + '</p>' : '') +
      '<div class="tbc-gift-pick__image">' +
        (gift.image ? '<img src="' + escapeHTML(sized(gift.image)) + '" alt="" width="48" height="48" loading="lazy">' : '') +
      '</div>' +
      '<div class="tbc-gift-pick__body">' +
        '<p class="tbc-gift-pick__title" id="' + id + '-title">' +
          (inDrawer ? '<span class="visually-hidden">' + escapeHTML(strings.gifts || '') + ': </span>' : '') +
          escapeHTML(gift.title) +
        '</p>' +
        '<span class="cart__gift-free">' + escapeHTML(strings.free || '') + '</span>' +
        '<p class="tbc-gift-pick__hint" id="' + id + '-hint">' + escapeHTML(hint(gift)) + '</p>' +
        '<div class="tbc-gift-pick__cells">' + cells + '</div>' +
        '<p class="tbc-gift-pick__error" data-tbc-gift-error hidden></p>' +
      '</div>';

    block.addEventListener('click', function (event) {
      var cell = event.target.closest('.tbc-gift-pick__cell');
      if (!cell || cell.getAttribute('aria-disabled') === 'true' || busy) return;
      if (event.detail > 0 && (event.detail > 1 || pressed !== cell.getAttribute('data-variant') || Date.now() - shownAt < SETTLE_MS)) return;
      var variantId = Number(cell.getAttribute('data-variant'));
      choose(block, cell, gift, variantId);
    });

    return block;
  }

  function sized(url) {
    return url + (url.indexOf('?') === -1 ? '?' : '&') + 'width=120';
  }

  function escapeHTML(text) {
    return String(text).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  function render() {
    document.querySelectorAll('cart-items').forEach(function (holder) {
      holder.querySelectorAll('[data-tbc-gift-pick], [data-tbc-gift-heading]').forEach(function (node) { node.remove(); });
      if (!gifts.length || !holder.querySelector('.cart__item')) return;

      var inDrawer = !!holder.closest('#cart-drawer');
      var anchor = holder.firstChild;
      if (inDrawer && !holder.querySelector('.cart__gifts__title')) {
        var heading = document.createElement('p');
        heading.className = 'cart__gifts__title';
        heading.setAttribute('data-tbc-gift-heading', '');
        heading.setAttribute('aria-hidden', 'true');
        heading.textContent = strings.gifts || '';
        holder.appendChild(heading);
      }

      /* Drawer: first in the gift group (flex order, see "16. Cart" in
         tbc.css). Cart page: after the lines. */
      var counts = {};
      var seen = {};
      gifts.forEach(function (gift) { counts[gift.offer] = (counts[gift.offer] || 0) + 1; });
      gifts.forEach(function (gift) {
        var place = { index: seen[gift.offer] || 0, size: counts[gift.offer] };
        seen[gift.offer] = place.index + 1;
        var block = build(gift, inDrawer, place);
        if (inDrawer) holder.insertBefore(block, anchor);
        else holder.appendChild(block);
      });
    });
    gifts.forEach(loadStock);
  }

  function setBusy(block, cell, on) {
    if (on) {
      block.setAttribute('aria-busy', 'true');
      cell.setAttribute('aria-busy', 'true');
    } else {
      block.removeAttribute('aria-busy');
      cell.removeAttribute('aria-busy');
    }
  }

  /* The app's add function can fail after the line is in (its own pop-up is
     missing), so the cart itself says whether the gift went in. */
  function inCart(variantId) {
    return fetch(root() + 'cart.js', { headers: { Accept: 'application/json' } })
      .then(function (response) { return response.json(); })
      .then(function (cart) {
        return cart.items.some(function (item) { return item.variant_id === variantId; });
      })
      .catch(function () { return false; });
  }

  /* The shopper's pick per offer, for this visit. The gift app forgets a
     picked gift whenever the cart's lines are rewritten (a bundle piece
     being marked, assets/tbc-bundles.js) and asks again; the same pick is
     then made again for them, through the app's own function, once or twice
     per offer and page at most. Removing the gift forgets the pick. */
  var PICKS = 'tbc-gift-picks';
  var repicks = {};

  function readPicks() {
    try { return JSON.parse(sessionStorage.getItem(PICKS)) || {}; } catch (error) { return {}; }
  }

  function writePicks(picks) {
    try { sessionStorage.setItem(PICKS, JSON.stringify(picks)); } catch (error) {}
  }

  function remember(offer, variantId) {
    var picks = readPicks();
    picks[offer] = String(variantId);
    writePicks(picks);
  }

  function forget(variantId) {
    var picks = readPicks();
    Object.keys(picks).forEach(function (offer) {
      if (picks[offer] === String(variantId)) delete picks[offer];
    });
    writePicks(picks);
  }

  /* A gift the shopper already picked: added again without showing the
     choice. Returns whether one was started. */
  function repick() {
    var picks = readPicks();
    var gift = gifts.filter(function (item) {
      var variantId = picks[item.offer];
      return variantId && (repicks[item.offer] || 0) < 2 && !soldOut[variantId] &&
        item.variants.some(function (variant) { return String(variant.id) === variantId; });
    })[0];
    if (!gift || !addGift) return false;
    var variantId = Number(picks[gift.offer]);
    repicks[gift.offer] = (repicks[gift.offer] || 0) + 1;
    busy = true;
    Promise.race([
      Promise.resolve().then(function () { return addGift(variantId, 1, gift.offer); }),
      new Promise(function (resolve) { setTimeout(resolve, 15000); })
    ])
      .catch(function () {})
      .then(function () { return inCart(variantId); })
      .then(function (added) {
        busy = false;
        if (added) gifts = gifts.filter(function (item) { return item.offer !== gift.offer; });
        refreshCart();
      });
    return true;
  }

  function choose(block, cell, gift, variantId) {
    busy = true;
    setBusy(block, cell, true);
    var error = block.querySelector('[data-tbc-gift-error]');
    error.hidden = true;

    Promise.resolve()
      .then(function () {
        return Promise.race([
          addGift(variantId, 1, gift.offer),
          new Promise(function (resolve) { setTimeout(resolve, 15000); })
        ]);
      })
      .catch(function () {})
      .then(function () { return inCart(variantId); })
      .then(function (added) {
        busy = false;
        if (added) {
          remember(gift.offer, variantId);
          gifts = gifts.filter(function (item) { return item.offer !== gift.offer; });
          focusVariant = block.contains(document.activeElement) ? variantId : null;
          announce(strings.added);
          refreshCart();
          return;
        }
        setBusy(block, cell, false);
        error.textContent = strings.error || '';
        error.hidden = false;
        announce(strings.error);
      });
  }

  function refreshCart() {
    if (/\/cart\/?$/.test(location.pathname)) {
      location.reload();
      return;
    }
    var drawerItems = document.querySelector('#cart-drawer cart-items');
    if (drawerItems && typeof drawerItems.getCart === 'function') drawerItems.getCart();
    else render();
  }

  /* After a rebuild the chosen gift is a cart line: focus moves to it. */
  function restoreFocus() {
    if (!focusVariant) return;
    var link = document.querySelector('#cart-drawer .cart__item--gift .cart__item__title a[href*="variant=' + focusVariant + '"]');
    if (!link) return;
    focusVariant = null;
    link.focus({ preventScroll: true });
  }

  document.addEventListener('fg-gifts:show-slider', function (event) {
    var detail = event.detail || {};
    if (typeof detail.addGiftToCartFunc !== 'function' || !document.querySelector('cart-items')) return;
    var list = normalize(detail);
    if (!list.length) return;
    var known = gifts.map(function (gift) { return gift.offer; });
    if (list.some(function (gift) { return known.indexOf(gift.offer) === -1; })) shownAt = Date.now();
    html.classList.add('tbc-gifts-inline');
    addGift = detail.addGiftToCartFunc;
    gifts = list;
    stale = false;
    if (busy) return;
    if (!repick()) render();
  });

  /* Removing a gift line on purpose forgets its pick. The gift's title link
     carries its variant. */
  document.addEventListener('click', function (event) {
    var remove = event.target.closest && event.target.closest('.cart__item--gift [data-item-remove]');
    if (!remove) return;
    var link = remove.closest('.cart__item--gift').querySelector('a[href*="variant="]');
    var match = link && link.getAttribute('href').match(/variant=(\d+)/);
    if (match) forget(match[1]);
  }, true);

  document.addEventListener('pointerdown', function (event) {
    var cell = event.target.closest && event.target.closest('.tbc-gift-pick__cell');
    pressed = cell ? cell.getAttribute('data-variant') : null;
  }, true);

  document.addEventListener('theme:cart-drawer:open', function () {
    shownAt = Date.now();
  });

  document.addEventListener('fg-cart:start-process', function () {
    stale = true;
  });

  document.addEventListener('fg-cart:end-process', function () {
    clearTimeout(staleTimer);
    staleTimer = setTimeout(function () {
      if (!stale || busy || !gifts.length) return;
      gifts = [];
      render();
    }, 400);
  });

  document.addEventListener('theme:cart:change', function () {
    if (!busy) render();
    restoreFocus();
  });
})();
